import { render } from "./Feed.vue?vue&type=template&id=3107f82a&ts=true"
import script from "./Feed.vue?vue&type=script&lang=ts"
export * from "./Feed.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/levelpro-feed-widget/levelpro-feed-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__